import Navbar from "../../components/navbar/Navbars";
import Walk from "./Walk.js";
import About from "./About.js";
import Mywork from "./myWork/MyWork.js";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import i1 from "./assets_home/1.svg";
import i2 from "./assets_home/2.svg";
import i3 from "./assets_home/3.svg";
import i4 from "./assets_home/4.svg";
import i5 from "./assets_home/5.svg";
import i6 from "./assets_home/6.svg";
import i7 from "./assets_home/7.svg";
import i8 from "./assets_home/8.svg";
import i9 from "./assets_home/9.svg";
import i10 from "./assets_home/10.svg";
import i11 from "./assets_home/12.svg";
import i12 from "./assets_home/11.svg";

import wa from "./assets_home/wa.png";
import ig from "./assets_home/ig.png";
import dc from "./assets_home/dc.png";
import gm from "./assets_home/gm.png";

import "./home.css";
import Timeline from "./timeline/Timeline.js";
import Contact from "./contact/Contacts.js";
import { useEffect, useState } from "react";

import CV from "./assets_home/CV_Iwaldi_Putra.png";

const icons = [
  { image: i2, label: "React Js" },
  { image: i11, label: "Express Js" },
  { image: i8, label: "Laravel" },
  { image: i12, label: "Node Js" },

  { image: i3, label: "MySql" },
  { image: i9, label: "Javascript" },

  { image: i4, label: "PHP" },
  { image: i5, label: "HTML" },
  { image: i6, label: "CSS" },
  { image: i7, label: "Bootstrap" },
  { image: i10, label: "Three Js" },
  { image: i1, label: "Babylon Js" },
];

const Home = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(1);
  const increment = 1;

  const handleData = () => {
    // Simulate loading progress
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + increment;
        if (newProgress >= 100) {
          clearInterval(interval);
          setLoading(false);
          return 100;
        }
        return newProgress;
      });
    }, 50);

    setTimeout(() => {
      clearInterval(interval);
      setLoading(false);
    }, 5000);
  };

  useEffect(() => {
    console.log("Loading:", loading);
  }, [loading]);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 100,
      once: false,
    });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className={`loadingHome ${loading ? "show" : "hide"}`}>
        <div
          style={{ height: "100%", position: "relative", overflow: "hidden" }}
          className="d-flex justify-content-center align-items-center"
        >
          <p className="text-center">Loading {progress}%</p>{" "}
        </div>
      </div>

      <Navbar></Navbar>
      <div>
        {/* home */}
        <div id="home" className="section" style={{ height: "100%" }}>
          <div style={{ position: "relative", overflowX: "hidden" }}>
            <Walk onLoad={handleData}></Walk>{" "}
            <div className="dividerWalk"></div>
            <div className="areaWalk">
              <h1 style={{ fontWeight: "700" }} className="mb-3 textWalkTitle">
                Hi, <br /> I am Iwaldi Putra
              </h1>

              <h5 className="text-white textWalk2">I am Frontend Programmer</h5>
              <p className="textWalk">Live in Bandung</p>
              <button
                onClick={() => navigate("/rooms")}
                className="btn btn-sm text-white btn-walk px-4 mt-2 "
              >
                Explore My Room
              </button>
            </div>
          </div>
        </div>
        {/* about */}
        <div>
          <div
            id="about"
            style={{
              height: "100%",
              maxHeight: "250vh",
              paddingTop: "100px",
              paddingBottom: "50px",
              position: "relative",
              overflowX: "hidden",
            }}
            className="section d-flex flex-column justify-content-center"
          >
            <div className="container " style={{ position: "relative" }}>
              <h1 className="text-center">About Me</h1>
              <p style={{ opacity: "60%" }} className="text-center mx-2">
                Get to know more about my self
              </p>
              <hr
                className="mx-auto"
                style={{ width: "100px", color: "white" }}
              />

              <div className="row px-2">
                <div className="col-sm-12 col-md-12 col-lg-6 mb-5">
                  <div style={{ position: "relative" }}>
                    <About onLoad={handleData}></About>
                    <div className="transitionAbout"></div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 mb-5">
                  <div
                    style={{ maxHeight: "110vh", minHeight: "60vh" }}
                    className="d-flex flex-column justify-content-center"
                    data-aos="fade-left"
                    data-aos-anchor-placement="top-bottom"
                  >
                    <br />
                    <h4 className=" mb-3 text-white textWalkTitle">
                      Introduction
                    </h4>
                    <p className="textAbout">
                      I am a man born in 1996 in Bandung, currently I live in
                      Bandung. <br /> I am someone who likes new things,
                      especially in programming. The reason I like programming
                      is that I think it is very possible to create whatever i
                      want, even things that I previously thought were
                      impossible.
                    </p>
                    <p className="textAbout">
                      I have a total of 4 years of experience as a programmer.
                      Mostly I use the React js, Express js and Laravel
                      frameworks, apart from that I am used to working using
                      restfull api. I am always passionate about learning new
                      technologies and strive to provide clean quality code{" "}
                    </p>
                    <br />
                    <h4 className=" mb-2 text-white textWalkTitle">
                      Technology
                    </h4>
                    <div className="icon-grid">
                      {icons.map((icon, index) => (
                        <div key={index} className="icon-item">
                          <img
                            src={icon.image}
                            className="iconAbout"
                            alt={`icon-${index + 1}`}
                          />
                          <p className="textIconLabel mb-0 mt-1">
                            {icon.label}
                          </p>
                        </div>
                      ))}
                    </div>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="about"
            style={{
              height: "100%",
              paddingTop: "50px",
              paddingBottom: "100px",
              position: "relative",
              overflowX: "hidden",
            }}
            className="section d-flex flex-column justify-content-center"
          >
            <div className="container " style={{ position: "relative" }}>
              <h1 className="text-center">My Journey</h1>
              <p style={{ opacity: "60%" }} className="text-center mx-2">
                Get to know more about my journey
              </p>
              <hr
                className="mx-auto"
                style={{ width: "100px", color: "white" }}
              />
              <br />
              <Timeline />
            </div>
          </div>
        </div>
        {/* my work */}
        <div
          id="myWork"
          style={{
            height: "100%",
            paddingTop: "100px",
            paddingBottom: "100px",
            position: "relative",
            overflowX: "hidden",
          }}
          className="section d-flex flex-column justify-content-center"
        >
          <div className="container " style={{ position: "relative" }}>
            <h1 className="text-center">My Work</h1>
            <p style={{ opacity: "60%" }} className="text-center mx-2">
              Projects that I have worked on
            </p>
            <hr
              className="mx-auto"
              style={{ width: "100px", color: "white" }}
            />
            <br />
            <br />
            <Mywork />
          </div>
        </div>
        {/* contact */}
        <div
          id="contact"
          style={{
            height: "100%",
            paddingBottom: "30px",
            position: "relative",
            overflowX: "hidden",
          }}
          className="section d-flex flex-column justify-content-center"
        >
          <div className="container " style={{ position: "relative" }}>
            <h1 className="text-center">Contact</h1>
            <p style={{ opacity: "60%" }} className="text-center mx-2">
              Contact me and send me a message
            </p>
            <hr
              className="mx-auto"
              style={{ width: "100px", color: "white" }}
            />
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-6 mb-4">
                <Contact onLoad={handleData} />
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6 mb-4">
                <div
                  style={{
                    height: "100%",
                    position: "relative",
                  }}
                  className="d-flex flex-column justify-content-center p-2"
                >
                  <div
                    className="bgWork"
                    style={{
                      width: "100%",
                    }}
                  >
                    <div className="hexagons"></div>
                    <div className="hexagons2"></div>
                    <div className="hexagons3"></div>
                  </div>
                  <div
                    className="cardContact p-4 py-5"
                    data-aos="fade-left"
                    data-aos-anchor-placement="top-bottom"
                  >
                    <div className="d-flex align-items-center mb-5">
                      <img className="iconContact" src={wa} alt="" />
                      <p className="textContact ms-3">+6282117384510</p>
                    </div>
                    <div className="d-flex align-items-center mb-5">
                      <img className="iconContact" src={gm} alt="" />
                      <p className="textContact ms-3">iwaldiputra@gmail.com</p>
                    </div>

                    <div className="d-flex align-items-center mb-5">
                      <img className="iconContact" src={dc} alt="" />
                      <p className="textContact ms-3">
                        https://discord.gg/2Jg9WwWa
                      </p>
                    </div>

                    <div className="d-flex align-items-center">
                      <img className="iconContact" src={ig} alt="" />
                      <p className="textContact ms-3">@iwaldiputra</p>
                    </div>
                  </div>
                  {/* <a
                    data-aos="fade-left"
                    data-aos-anchor-placement="top-bottom"
                    href={CV}
                    className="btn btn-sm text-white btn-walk px-4 mt-4 "
                  >
                    Download My CV
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* footer */}
        <div className="footer  p-3">
          <p className="mb-0  text-center">
            ©Copyright 2024. Lux All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
